// This file is auto-generated. Do not modify directly.
// biome-ignore: auto-generated file
// biome-ignore format: auto-generated file
// eslint-disable

export const productCatalog = {
  "A-100": {
    "productType": null,
    "displayName": "BL staff Member - Blue Lagoon Admission",
    "fullName": "BL staff Member - Blue Lagoon Admission"
  },
  "A-101": {
    "productType": null,
    "displayName": "BL staff Invited guest - Blue Lagoon Admission",
    "fullName": "BL staff Invited guest - Blue Lagoon Admission"
  },
  "A-102": {
    "productType": null,
    "displayName": "BL staff Invited child - Blue Lagoon Admission",
    "fullName": "BL staff Invited child - Blue Lagoon Admission"
  },
  "A-102A": {
    "productType": null,
    "displayName": "BL Staff invited child",
    "fullName": "BL Staff invited child"
  },
  "A-BL-404": {
    "productType": null,
    "displayName": "Children's BL SPA Access",
    "fullName": "Children's BL SPA Access"
  },
  "A-BL-410A": {
    "productType": null,
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "A-BL-416": {
    "productType": null,
    "displayName": "Comfort - Child",
    "fullName": "Comfort - Child"
  },
  "A-BL-417": {
    "productType": null,
    "displayName": "Comfort - S",
    "fullName": "Comfort - S"
  },
  "A-BL-420A": {
    "productType": null,
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "A-BL-428": {
    "productType": null,
    "displayName": "Premium - Child",
    "fullName": "Premium - Child"
  },
  "A-BL-429": {
    "productType": null,
    "displayName": "Premium - S",
    "fullName": "Premium - S"
  },
  "A-BL-430": {
    "productType": null,
    "displayName": "Signature",
    "fullName": "Signature"
  },
  "API-BL-410A": {
    "productType": "Admission",
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "API-BL-420A": {
    "productType": "Admission",
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "ARCTIC EXPOSURE": {
    "productType": null,
    "displayName": "Guided Reykjanes Photo Tour",
    "fullName": "Guided Reykjanes Photo Tour"
  },
  "B-071": {
    "productType": "Admission",
    "displayName": "BL Winter Card - Individual Admission",
    "fullName": "BL Winter Card - Individual Admission"
  },
  "B-138": {
    "productType": "Admission",
    "displayName": "BL Summer Card - Individual Admission",
    "fullName": "BL Summer Card - Individual Admission"
  },
  "B-217": {
    "productType": "Massage",
    "displayName": "30 min - In Water Relaxing Massage",
    "fullName": "30 min-In Water Relaxing Massage"
  },
  "B-218": {
    "productType": "Massage",
    "displayName": "60 min - In Water Relaxing Massage",
    "fullName": "60 min-In Water Relaxing Massage"
  },
  "B-229": {
    "productType": "Massage",
    "displayName": "Signature Treatment: 120 min of Wonder",
    "fullName": "Signature Treatment: 120 min of Wonder"
  },
  "B-230": {
    "productType": "Massage",
    "displayName": "Floating for one",
    "fullName": "Floating for one "
  },
  "B-230A": {
    "productType": "Massage",
    "displayName": "Floating for two",
    "fullName": "Floating for two"
  },
  "B-230B": {
    "productType": "Massage",
    "displayName": "Group Float",
    "fullName": "Floating - Samflot"
  },
  "B-231": {
    "productType": "Massage",
    "displayName": "Group Float - BL",
    "fullName": "Group Float Activity"
  },
  "G-BL-404": {
    "productType": "Admission",
    "displayName": "Children",
    "fullName": "Children's BL SPA Access"
  },
  "G-BL-410A": {
    "productType": "Admission",
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "G-BL-420A": {
    "productType": "Admission",
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "G-BL-430": {
    "productType": "Admission",
    "displayName": "Signature",
    "fullName": "Signature"
  },
  "G-BL-430A": {
    "productType": "Admission",
    "displayName": "Seasonal",
    "fullName": "Valentines "
  },
  "G-BL-430B": {
    "productType": "Admission",
    "displayName": "Seasonal",
    "fullName": "Easter Break"
  },
  "G-BL-430C": {
    "productType": "Admission",
    "displayName": "Seasonal Midnight Sun",
    "fullName": "Season of brightness"
  },
  "G-BL-430D": {
    "productType": "Admission",
    "displayName": "Seasonal Midnight Sun Event",
    "fullName": "Solstice concert admission"
  },
  "G-BL-430F": {
    "productType": null,
    "displayName": "Solar Eclipse ",
    "fullName": "Solar Eclipse "
  },
  "H-TA39": {
    "productType": null,
    "displayName": "Blowdry and hairstyling",
    "fullName": "Blowdry and hairstyling"
  },
  "INTOTHEGLACIER": {
    "productType": null,
    "displayName": "Into The Glacier",
    "fullName": "Into The Glacier"
  },
  "KATLA TRACK-1": {
    "productType": null,
    "displayName": "Katla Ice Cave Tour - Fast Track",
    "fullName": "Katla Ice Cave Tour - Fast Track"
  },
  "KATLA TRACK-2": {
    "productType": null,
    "displayName": "Katla Ice Cave Tour",
    "fullName": "Katla Ice Cave Tour"
  },
  "KATLA TRACK-3": {
    "productType": null,
    "displayName": "Black Beach Buggy Tour",
    "fullName": "Black Beach Buggy Tour"
  },
  "LAVA-RES": {
    "productType": "Restaurant",
    "displayName": "LAVA Table Reservation",
    "fullName": "LAVA Table Reservation"
  },
  "MOSS-RES": {
    "productType": "Restaurant",
    "displayName": "MOSS Table Reservation",
    "fullName": "MOSS Table Reservation"
  },
  "OSCIETRA CAVIAR": {
    "productType": null,
    "displayName": "Private wine tasting in Moss wine cellar - Oscietra caviar",
    "fullName": "Private wine tasting in Moss wine cellar - Oscietra caviar"
  },
  "PRESTIGE CUVÉE": {
    "productType": null,
    "displayName": "Private wine tasting in Moss wine cellar - Prestige Cuvée + Beluga caviar",
    "fullName": "Private wine tasting in Moss wine cellar - Prestige Cuvée + Beluga caviar"
  },
  "PRIVATE WINETASTING": {
    "productType": null,
    "displayName": "Private wine tasting in Moss wine cellar - 4glasses+cheeses",
    "fullName": "Private wine tasting in Moss wine cellar - 4glasses+cheeses"
  },
  "R-105": {
    "productType": "Transfer",
    "displayName": "DBL Two way transfer",
    "fullName": "Two way transfer - All booking members included"
  },
  "SERVIO - 11": {
    "productType": null,
    "displayName": "Snæfellsnes Peninsula Tour",
    "fullName": "Snæfellsnes Peninsula Tour"
  },
  "SERVIO - 12": {
    "productType": null,
    "displayName": "Reykjavík Sightseeing Tour",
    "fullName": "Reykjavík Sightseeing Tour"
  },
  "SERVIO - 2": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Blue Lagoon - Kef Airport - Luxury Sedan (1-2 pax)",
    "fullName": "Transfer - Blue Lagoon - Kef Airport - Luxury Sedan (1-2 pax)"
  },
  "SERVIO - 2A": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Blue Lagoon - Kef Airport - Business Minivan (1-4 pax)",
    "fullName": "Transfer - Blue Lagoon - Kef Airport - Business Minivan (1-4 pax)"
  },
  "SERVIO - 2B": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Blue Lagoon - Kef Airport - Sprinter (1-9 pax)",
    "fullName": "Transfer - Blue Lagoon - Kef Airport - Sprinter (1-9 pax)"
  },
  "SERVIO - 3": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Kef Airport - BL -  Luxury Sedan (1-2 pax)",
    "fullName": "Transfer - Kef Airport - BL -  Luxury Sedan (1-2 pax) "
  },
  "SERVIO - 3A": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer -  Kef Airport - BL  - Business Minivan (1-4 pax)",
    "fullName": "Transfer -  Kef Airport - BL  - Business Minivan (1-4 pax)"
  },
  "SERVIO - 3B": {
    "productType": "PrivateTransfer",
    "displayName": "Transfer - Kef Airport - BL  - Sprinter (1-9 pax)",
    "fullName": "Transfer - Kef Airport - BL  - Sprinter (1-9 pax)"
  },
  "SPA-RES": {
    "productType": "Restaurant",
    "displayName": "SPA Restaurant Table Reservation",
    "fullName": "Spa Restaurant Table Reservation"
  },
  "T-100": {
    "productType": "Admission",
    "displayName": "The Retreat Spa",
    "fullName": "The Retreat SPA"
  },
  "T-100I": {
    "productType": "Admission",
    "displayName": "The Retreat SPA - Full Day Access",
    "fullName": "Retreat Spa - Full Day Access"
  },
  "T-110": {
    "productType": "Admission",
    "displayName": "Lava Cove",
    "fullName": "Lava Cove"
  },
  "VALDEMAR - 13": {
    "productType": "PrivateTransfer",
    "displayName": "Blue Lagoon - KEF Airport(4-8pax)",
    "fullName": "Taxi Transfer - Blue Lagoon - KEF Airport (4-8pax)"
  },
  "VALDEMAR - 14": {
    "productType": "PrivateTransfer",
    "displayName": "KEF Airport - Blue Lagoon(4-8pax)",
    "fullName": "Taxi Transfer - KEF Airport - Blue Lagoon (4-8pax)"
  },
  "VALDEMAR - 16": {
    "productType": null,
    "displayName": "Taxi Transfer - Blue Lagoon - Reykjavík (4-8)",
    "fullName": "Taxi Transfer - Blue Lagoon - Reykjavík (4-8)"
  },
  "VALDEMAR - 17": {
    "productType": null,
    "displayName": "Taxi Transfer - Reykjavík - Blue Lagoon (4-8)",
    "fullName": "Taxi Transfer - Reykjavík - Blue Lagoon (4-8)"
  },
  "VALDEMAR - 2": {
    "productType": "PrivateTransfer",
    "displayName": "Blue Lagoon - KEF Airport(1-3pax)",
    "fullName": "Taxi Transfer - Blue Lagoon - KEF Airport (1-3pax)"
  },
  "VALDEMAR - 3": {
    "productType": "PrivateTransfer",
    "displayName": "KEF Airport - Blue Lagoon(1-3pax)",
    "fullName": "Taxi Transfer - KEF Airport - Blue Lagoon (1-3pax)"
  },
  "V-MOS-4000": {
    "productType": null,
    "displayName": "Prestige Wine Tasting",
    "fullName": "Prestige Wine Tasting"
  },
  "BL1B01F1": {
    "productType": "Item",
    "displayName": "Silica Mud Mask 75ml",
    "fullName": "Silica Mud Mask 75ml"
  },
  "V-MOK-4001": {
    "productType": "Item",
    "displayName": "Moss 7-course menu",
    "fullName": "Moss 7-course menu"
  },
  "BL4B05M4": {
    "productType": "Item",
    "displayName": "Signature travel mask kit",
    "fullName": "Signature travel mask kit"
  },
  "BL4B06F": {
    "productType": "Item",
    "displayName": "Ritual kit",
    "fullName": "Ritual kit"
  },
  "BL4N30F": {
    "productType": "Item",
    "displayName": "Skin saviour",
    "fullName": "Skin saviour"
  },
  "BL4B05F-1": {
    "productType": "Item",
    "displayName": "Signature mask full size",
    "fullName": "Signature mask full size"
  },
  "BL1N20F": {
    "productType": "Item",
    "displayName": "BL+ the serum 30ml",
    "fullName": "BL+ the serum 30ml"
  },
  "RETREAT-LAGO": {
    "productType": "Hotel",
    "displayName": "Lagoon View Junior King",
    "fullName": "KING"
  },
  "RETREAT-LASU": {
    "productType": "Hotel",
    "displayName": "Lagoon Suite",
    "fullName": "KING"
  },
  "RETREAT-LATW": {
    "productType": "Hotel",
    "displayName": "Lava View Junior Twin",
    "fullName": "TWIN"
  },
  "RETREAT-LAVA": {
    "productType": "Hotel",
    "displayName": "Lava View Junior King",
    "fullName": "KING"
  },
  "RETREAT-MOSS": {
    "productType": "Hotel",
    "displayName": "Moss Junior suite King",
    "fullName": "KING"
  },
  "RETREAT-MOSU": {
    "productType": "Hotel",
    "displayName": "Moss suite King",
    "fullName": "KING"
  },
  "RETREAT-MOTW": {
    "productType": "Hotel",
    "displayName": "Moss Junior suite Twin",
    "fullName": "TWIN"
  },
  "RETREAT-ALL": {
    "productType": "Hotel",
    "displayName": "All room types",
    "fullName": "All Retreat Hotel room types"
  },
  "SILICA-LAKI": {
    "productType": "Hotel",
    "displayName": "Lava Deluxe King",
    "fullName": "KING"
  },
  "SILICA-LATW": {
    "productType": "Hotel",
    "displayName": "Lava Deluxe Twin",
    "fullName": "TWIN"
  },
  "SILICA-MOKI": {
    "productType": "Hotel",
    "displayName": "Mountain Deluxe King",
    "fullName": "KING"
  },
  "SILICA-MOTW": {
    "productType": "Hotel",
    "displayName": "Mountain Deluxe Twin",
    "fullName": "TWIN"
  },
  "SILICA-SILI": {
    "productType": "Hotel",
    "displayName": "SILI",
    "fullName": "KING"
  },
  "SILICA-ALL": {
    "productType": "Hotel",
    "displayName": "All room types",
    "fullName": "All Silica Hotel room types"
  },
  "BL4N22F": {
    "productType": "Item",
    "displayName": "Discovery BL+",
    "fullName": "Discovery BL+"
  },
  "BL4B05F2-4": {
    "productType": "InRoom",
    "displayName": "Signature full size mask kit",
    "fullName": "Signature full size mask kit"
  },
  "BL4N20F": {
    "productType": "InRoom",
    "displayName": "BL+ signature kit",
    "fullName": "BL+ signature kit"
  },
  "BL4N49F": {
    "productType": "InRoom",
    "displayName": "The Ultimate Indulgence",
    "fullName": "The Ultimate Indulgence"
  },
  "BL1N21F": {
    "productType": "InRoom",
    "displayName": "BL+ eye serum 10ml",
    "fullName": "BL+ eye serum 10ml"
  },
  "BL1N26F": {
    "productType": "InRoom",
    "displayName": "BL+ the cream 50ml",
    "fullName": "BL+ the cream 50ml"
  },
  "BL1N30M": {
    "productType": "InRoom",
    "displayName": "BL+ eye cream 15ml",
    "fullName": "BL+ eye cream 15ml"
  },
  "V-ROM-100": {
    "productType": "InRoom",
    "displayName": "Mixed Fruits",
    "fullName": "Mixed Fruits"
  },
  "V-ROM-101": {
    "productType": "InRoom",
    "displayName": "Omelette",
    "fullName": "Omelette"
  },
  "V-ROM-102": {
    "productType": "InRoom",
    "displayName": "Egg White Omelette",
    "fullName": "Egg White Omelette"
  },
  "V-ROM-103": {
    "productType": "InRoom",
    "displayName": "Scrambled Eggs",
    "fullName": "Scrambled Eggs"
  },
  "V-ROM-104": {
    "productType": "InRoom",
    "displayName": "Crispy Bacon",
    "fullName": "Crispy Bacon"
  },
  "V-ROM-105": {
    "productType": "InRoom",
    "displayName": "Roasted Potatoes",
    "fullName": "Roasted Potatoes"
  },
  "V-ROM-106": {
    "productType": "InRoom",
    "displayName": "Oatmeal",
    "fullName": "Oatmeal"
  },
  "V-ROM-107": {
    "productType": "InRoom",
    "displayName": "Skyr",
    "fullName": "Skyr"
  },
  "V-ROM-108": {
    "productType": "InRoom",
    "displayName": "Vegetable Tray",
    "fullName": "Vegetable Tray"
  },
  "V-ROM-109": {
    "productType": "InRoom",
    "displayName": "Croissant",
    "fullName": "Croissant"
  },
  "V-ROM-110": {
    "productType": "InRoom",
    "displayName": "Gluten free bread",
    "fullName": "Gluten free bread"
  },
  "V-ROM-111": {
    "productType": "InRoom",
    "displayName": "Muffins",
    "fullName": "Muffins"
  },
  "V-ROM-112": {
    "productType": "InRoom",
    "displayName": "Chocolate and dates",
    "fullName": "Chocolate and dates"
  },
  "V-ROM-114": {
    "productType": "InRoom",
    "displayName": "Vegan Meatballs",
    "fullName": "Vegan Meatballs"
  },
  "V-ROM-204": {
    "productType": "InRoom",
    "displayName": "Cod",
    "fullName": "Cod"
  },
  "V-ROM-205": {
    "productType": "InRoom",
    "displayName": "Sushi",
    "fullName": "Sushi"
  },
  "V-ROM-210": {
    "productType": "InRoom",
    "displayName": "Burrata",
    "fullName": "Burrata"
  },
  "V-ROM-211": {
    "productType": "InRoom",
    "displayName": "Mediterranean Salad",
    "fullName": "Mediterranean Salad"
  },
  "V-ROM-212": {
    "productType": "InRoom",
    "displayName": "Tuna Tartare",
    "fullName": "Tuna Tartare"
  },
  "V-ROM-300": {
    "productType": "InRoom",
    "displayName": "Aubergine hummus",
    "fullName": "Aubergine hummus"
  },
  "V-ROM-303": {
    "productType": "InRoom",
    "displayName": "Avocado & seed crackers",
    "fullName": "Avocado & seed crackers"
  },
  "V-ROM-304": {
    "productType": "InRoom",
    "displayName": "Hummus & seed crackers",
    "fullName": "Hummus & seed crackers"
  },
  "V-ROM-308": {
    "productType": "InRoom",
    "displayName": "Crudité and basil hummus - regular",
    "fullName": "Crudité and basil hummus - regular"
  },
  "V-ROM-309": {
    "productType": "InRoom",
    "displayName": "Crudité and basil hummus - large",
    "fullName": "Crudité and basil hummus - large"
  },
  "V-ROM-312": {
    "productType": "InRoom",
    "displayName": "Greek salad",
    "fullName": "Greek salad"
  },
  "V-ROM-314": {
    "productType": "InRoom",
    "displayName": "Farro salad",
    "fullName": "Farro salad"
  },
  "V-ROM-402": {
    "productType": "InRoom",
    "displayName": "Miso Soup",
    "fullName": "Miso Soup"
  },
  "V-ROM-403": {
    "productType": "InRoom",
    "displayName": "Beef Tataki",
    "fullName": "Beef Tataki"
  },
  "V-ROM-405": {
    "productType": "InRoom",
    "displayName": "Caesar Salad",
    "fullName": "Caesar Salad"
  },
  "V-ROM-404": {
    "productType": "InRoom",
    "displayName": "Grilled panini",
    "fullName": "Grilled panini"
  },
  "V-ROM-408": {
    "productType": "InRoom",
    "displayName": "Avocado toast",
    "fullName": "Avocado toast"
  },
  "V-ROM-409": {
    "productType": "InRoom",
    "displayName": "BLT sandwich",
    "fullName": "BLT sandwich"
  },
  "V-ROM-410": {
    "productType": "InRoom",
    "displayName": "Smoked salmon",
    "fullName": "Smoked salmon"
  },
  "V-ROM-411": {
    "productType": "InRoom",
    "displayName": "Carrots",
    "fullName": "Carrots"
  },
  "V-ROM-412": {
    "productType": "InRoom",
    "displayName": "Beluga Caviar",
    "fullName": "Beluga Caviar"
  },
  "V-ROM-413": {
    "productType": "InRoom",
    "displayName": "Oscietra Caviar",
    "fullName": "Oscietra Caviar"
  },
  "V-ROM-414": {
    "productType": "InRoom",
    "displayName": "Gold Selection Caviar",
    "fullName": "Gold Selection Caviar"
  },
  "V-ROM-500": {
    "productType": "InRoom",
    "displayName": "Fruit salad",
    "fullName": "Fruit salad"
  },
  "V-ROM-501": {
    "productType": "InRoom",
    "displayName": "Dark chocolate mousse",
    "fullName": "Dark chocolate mousse"
  },
  "V-ROM-502": {
    "productType": "InRoom",
    "displayName": "Créme Brulée",
    "fullName": "Créme Brulée"
  },
  "V-ROM-503": {
    "productType": "InRoom",
    "displayName": "Chocolate mousse and berries",
    "fullName": "Chocolate mousse and berries"
  },
  "T-112": {
    "productType": "InRoom",
    "displayName": "Room service charge",
    "fullName": "Room service charge"
  },
  "V-SPA-2030": {
    "productType": "InRoom",
    "displayName": "Potato Bread",
    "fullName": "Potato Bread"
  },
  "V-SPA-2029": {
    "productType": "InRoom",
    "displayName": "Grilled Broccolini",
    "fullName": "Grilled Broccolini"
  },
  "V-OLG-66502": {
    "productType": "Item",
    "displayName": "Moet & Chandon",
    "fullName": "Moet & Chandon"
  },
  "V-OLG-60442": {
    "productType": "Item",
    "displayName": "Prosecco",
    "fullName": "Prosecco"
  },
  "V-MOK-3004": {
    "productType": "Item",
    "displayName": "Chocolates and Strawberries",
    "fullName": "Chocolates and Strawberries"
  },
  "A-200": {
    "productType": "Admission",
    "displayName": "Admission adult",
    "fullName": "Bath Admission - Adult"
  },
  "A-201": {
    "productType": "Admission",
    "displayName": "Admission teenager",
    "fullName": "Bath Admission - Teenager"
  },
  "A-202": {
    "productType": "Admission",
    "displayName": "Admission child",
    "fullName": "Bath Admission - Child"
  },
  "BUGGY-1": {
    "productType": "Activity",
    "displayName": "BUGGY-1 · Buggy Single Ride - 1 hour",
    "fullName": "Buggy Single Ride  - 1 hour"
  },
  "BUGGY-2": {
    "productType": "Activity",
    "displayName": "BUGGY-2 · Buggy Double ride - 1 hour",
    "fullName": "Buggy Double ride - 1 hour"
  },
  "EBIKES": {
    "productType": "Activity",
    "displayName": "Bikes",
    "fullName": "E-Mountain Bike Tour"
  },
  "G-BL-100": {
    "productType": "Activity",
    "displayName": "Day Tour from Reykjavík",
    "fullName": "Day Tour from Reykjavík"
  },
  "G-BL-101": {
    "productType": "Activity",
    "displayName": "Day Tour from Gullfoss",
    "fullName": "Day Tour from Gullfoss"
  },
  "KER-HIKE4": {
    "productType": "Activity",
    "displayName": "Daily hike - Adult",
    "fullName": "Hverabotnar - Daily Hike"
  },
  "KER-HIKE4B": {
    "productType": "Activity",
    "displayName": "Daily hike - Teen",
    "fullName": "Hverabotnar - Daily Hike (Teen 12-16y)"
  },
  "KER-HIKE5": {
    "productType": "Activity",
    "displayName": "Solstice hike",
    "fullName": "Summer Solstice Hike"
  },
  "KER-HIKE6": {
    "productType": null,
    "displayName": "Fire & Ice Hike - Private",
    "fullName": "Fire & Ice Hike - Private"
  },
  "KER-HIKE6B": {
    "productType": null,
    "displayName": "Fire & Ice Hike (Teen 12-16y) - Private",
    "fullName": "Fire & Ice Hike (Teen 12-16y) - Private"
  },
  "KER-HIKE7": {
    "productType": null,
    "displayName": "Family Adventure Hike - Private",
    "fullName": "Family Adventure Hike - Private"
  },
  "KER-HIKE7B": {
    "productType": null,
    "displayName": "Family Adventure Hike (Teen 12-16y) - Private",
    "fullName": "Family Adventure Hike (Teen 12-16y) - Private"
  },
  "KER-HIKE8": {
    "productType": null,
    "displayName": "Loðmundur Mointain - Private",
    "fullName": "Loðmundur Mointain - Private"
  },
  "KER-HIKE9": {
    "productType": null,
    "displayName": "Snækollur - Private",
    "fullName": "Snækollur - Private"
  },
  "KER-RES": {
    "productType": "Restaurant",
    "displayName": "Highland Base Table Reservation",
    "fullName": "Kerlingafjöll Restaurant Table Reservation"
  },
  "SNOW-1": {
    "productType": "Activity",
    "displayName": "Snowmobile double ride",
    "fullName": "Snowmobiles Single Ride - 1 hour"
  },
  "SNOW-2": {
    "productType": "Activity",
    "displayName": "Snowmobile single ride",
    "fullName": "Snowmobiles Double Ride - 1 hour"
  },
  "SOUTH-10": {
    "productType": "Activity",
    "displayName": "Bus Transfer Gullfoss - HB - Gullfoss",
    "fullName": "Bus Transfer Gullfoss - HB - Gullfoss"
  },
  "SOUTH-11": {
    "productType": "Activity",
    "displayName": "Bus Transfer RVK-HB-RVK",
    "fullName": "Bus Transfer RVK-HB-RVK"
  },
  "SOUTH-6": {
    "productType": "Activity",
    "displayName": "Bus Transfer Reykjavík  - Highland Base",
    "fullName": "Bus Transfer Reykjavík  - Highland Base"
  },
  "SOUTH-7": {
    "productType": "Activity",
    "displayName": "Bus Transfer Gullfoss - Highland Base",
    "fullName": "Bus Transfer Gullfoss - Highland Base "
  },
  "SOUTH-8": {
    "productType": "Activity",
    "displayName": "Bus Transfer Highland Base - Reykjavík",
    "fullName": "Bus Transfer Highland Base - Reykjavík"
  },
  "SOUTH-9": {
    "productType": "Activity",
    "displayName": "Bus Transfer Higland Base - Gullfoss",
    "fullName": "Bus Transfer Higland Base - Gullfoss"
  },
  "TRANSFER-HB-RVK": {
    "productType": "Activity",
    "displayName": "Super Jeep HB to Reykjavik",
    "fullName": "Super Jeep transfer from Highland Base to Reykjavik"
  },
  "TRANSFER-HB-SKJOL": {
    "productType": "Activity",
    "displayName": "Super Jeep HB to Skjól",
    "fullName": "Super Jeep transfer from Highland Base to Skjól basecamp"
  },
  "TRANSFER-RVK-HB": {
    "productType": "Activity",
    "displayName": "Super Jeep Reykjavik to HB",
    "fullName": "Super Jeep Transfer from Reykjavik to Highland Base"
  },
  "TRANSFER-SKJOL-HB": {
    "productType": "Activity",
    "displayName": "Super Jeep Skjól to HB",
    "fullName": "Super Jeep transfer from Skjól Basecamp to Highland Base"
  },
  "KERLINGARFJOLL-DLX_DOUBLE": {
    "productType": "Hotel",
    "displayName": "Deluxe Double Room",
    "fullName": "DOUBLE"
  },
  "KERLINGARFJOLL-DLX_TWIN": {
    "productType": "Hotel",
    "displayName": "Deluxe Twin Room",
    "fullName": "TWIN"
  },
  "KERLINGARFJOLL-HUT_SB_15PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 10-15 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-HUT_SB_2PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 2 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-HUT_SB_3PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 3 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-HUT_SB_6PAX": {
    "productType": "Hotel",
    "displayName": "Hut for 4-6 guests",
    "fullName": "SLEEPING BAG"
  },
  "KERLINGARFJOLL-LODGE": {
    "productType": "Hotel",
    "displayName": "Highland Base Lodge",
    "fullName": "DOUBLE"
  },
  "KERLINGARFJOLL-LODGE+SOFABED": {
    "productType": "Hotel",
    "displayName": "Highland Base Lodge with sofa bed",
    "fullName": "DOUBLE + SOFABED"
  },
  "KERLINGARFJOLL-PREMIUM": {
    "productType": "Hotel",
    "displayName": "Deluxe Family Room",
    "fullName": "DOUBLE + SOFABED"
  },
  "KERLINGARFJOLL-STD_FAM": {
    "productType": "Hotel",
    "displayName": "Standard Family Room",
    "fullName": "QUEEN BUNK"
  },
  "KERLINGARFJOLL-STD_TWIN": {
    "productType": "Hotel",
    "displayName": "Standard Twin Room",
    "fullName": "TWIN"
  },
  "KERLINGARFJOLL-SUITE": {
    "productType": "Hotel",
    "displayName": "Highland Base Suite",
    "fullName": "DOUBLE"
  },
  "KERLINGARFJOLL-ALL": {
    "productType": "Hotel",
    "displayName": "All room types",
    "fullName": "All Highland Base room types"
  },
  "HB-BATH-ADULT": {
    "productType": "Admission",
    "displayName": "Highland Base Adult Admission",
    "fullName": "Highland Base Adult Admission"
  },
  "HB-BATH-CHILD": {
    "productType": "Admission",
    "displayName": "Child bath admission",
    "fullName": "Child bath admission"
  },
  "HB-BATH-TEEN": {
    "productType": "Admission",
    "displayName": "Teen bath admission",
    "fullName": "Teen bath admission"
  },
  "HB-BUGGY-1": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Buggy Single Ride - 1 hour",
    "fullName": "Buggy Single Ride - 1 hour"
  },
  "HB-BUGGY-2": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Buggy Double Ride - 1 hour",
    "fullName": "Buggy Double Ride - 1 hour"
  },
  "HB-DAY-TOUR-GULLFOSS": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Day Tour from Gullfoss",
    "fullName": "Day Tour from Gullfoss"
  },
  "HB-DAY-TOUR-RVK": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Day Tour from Reykjavík",
    "fullName": "Day Tour from Reykjavík"
  },
  "HB-EBIKE": {
    "productType": "Activity",
    "displayName": "Highland Base EBike",
    "fullName": "Highland Base EBike"
  },
  "HB-KER-HIKE4": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Daily hike - Adult",
    "fullName": "Daily hike - Adult"
  },
  "HB-KER-HIKE4B": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Daily hike - Teen",
    "fullName": "Daily hike - Teen"
  },
  "HB-KER-HIKE5": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Solstice hike",
    "fullName": "Solstice hike"
  },
  "HB-RES": {
    "productType": "Restaurant",
    "displayName": "Highland Base Restaurant",
    "fullName": "Highland Base Restaurant"
  },
  "HB-SNOW-1": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Snowmobile double ride",
    "fullName": "Snowmobile double ride"
  },
  "HB-SNOW-2": {
    "productType": "ActivityFixedNoPersons",
    "displayName": "Snowmobile single ride",
    "fullName": "Snowmobile single ride"
  },
  "HB-SOUTH-10": {
    "productType": "Transfer",
    "displayName": "Bus Transfer Gullfoss - HB - Gullfoss",
    "fullName": "Bus Transfer Gullfoss - HB - Gullfoss"
  },
  "HB-SOUTH-11": {
    "productType": "Transfer",
    "displayName": "Bus Transfer RVK-HB-RVK",
    "fullName": "Bus Transfer RVK-HB-RVK"
  },
  "HB-SOUTH-6": {
    "productType": "Transfer",
    "displayName": "Bus Transfer Reykjavík  - Highland Base",
    "fullName": "Bus Transfer Reykjavík  - Highland Base"
  },
  "HB-SOUTH-7": {
    "productType": "Transfer",
    "displayName": "Bus Transfer Gullfoss - Highland Base",
    "fullName": "Bus Transfer Gullfoss - Highland Base"
  },
  "HB-SOUTH-8": {
    "productType": "Transfer",
    "displayName": "Bus Transfer Highland Base - Reykjavík",
    "fullName": "Bus Transfer Highland Base - Reykjavík"
  },
  "HB-SOUTH-9": {
    "productType": "Transfer",
    "displayName": "Bus Transfer Higland Base - Gullfoss",
    "fullName": "Bus Transfer Higland Base - Gullfoss"
  },
  "HB-TRANSFER-HB-RVK": {
    "productType": "Transfer",
    "displayName": "Super Jeep HB to Reykjavik",
    "fullName": "Super Jeep HB to Reykjavik"
  },
  "HB-TRANSFER-HB-SKJOL": {
    "productType": "Transfer",
    "displayName": "Super Jeep HB to Skjól",
    "fullName": "Super Jeep HB to Skjól"
  },
  "HB-TRANSFER-RVK-HB": {
    "productType": "Transfer",
    "displayName": "Super Jeep Reykjavik to HB",
    "fullName": "Super Jeep Reykjavik to HB"
  },
  "HB-TRANSFER-SKJOL-HB": {
    "productType": "Transfer",
    "displayName": "Super Jeep Skjól to HB",
    "fullName": "Super Jeep Skjól to HB"
  },
  "retreatspaday": {
    "productType": "analyticsItem",
    "displayName": "Retreat Spa All Day",
    "fullName": "Retreat Spa All Day"
  },
  "valentines": {
    "productType": "analyticsItem",
    "displayName": "Valentines",
    "fullName": "Valentines"
  },
  "signature": {
    "productType": "analyticsItem",
    "displayName": "Signature",
    "fullName": "Signature"
  },
  "retreatspa": {
    "productType": "analyticsItem",
    "displayName": "Retreatspa",
    "fullName": "Retreatspa"
  },
  "premium": {
    "productType": "analyticsItem",
    "displayName": "Premium",
    "fullName": "Premium"
  },
  "comfort": {
    "productType": "analyticsItem",
    "displayName": "Comfort",
    "fullName": "Comfort"
  },
  "retreat": {
    "productType": "analyticsItem",
    "displayName": "Retreat Hotel",
    "fullName": "Retreat Hotel"
  },
  "silica": {
    "productType": "analyticsItem",
    "displayName": "Silica Hotel",
    "fullName": "Silica Hotel"
  },
  "AURORA_ADVENTURE": {
    "productType": "highlandPackage",
    "displayName": "Highland Aurora Adventure",
    "fullName": "Highland Aurora Adventure"
  },
  "SNOWMOBILE_NEW": {
    "productType": "highlandPackage",
    "displayName": "Snowmobiling in the Extremes",
    "fullName": "Snowmobiling in the Extremes"
  },
  "GONGUSKIDI": {
    "productType": "highlandPackage",
    "displayName": "Cross-Country Skiiing",
    "fullName": "Cross-Country Skiiing"
  },
  "EASTER": {
    "productType": "highlandPackage",
    "displayName": "Easter Special",
    "fullName": "Easter Special"
  },
  "ADVENT": {
    "productType": "highlandPackage",
    "displayName": "A festive getaway ",
    "fullName": "A festive getaway "
  },
  "SKIDA": {
    "productType": "highlandPackage",
    "displayName": "Ævintýralegt skíðanámskeið",
    "fullName": "Ævintýralegt skíðanámskeið"
  },
  "HBE_ONLINE": {
    "productType": "highlandPackage",
    "displayName": "Stay at Highland Base",
    "fullName": "Stay at Highland Base"
  },
  "2FYRIR1": {
    "productType": "highlandPackage",
    "displayName": " Tvær nætur á verði einnar í Kerlingarfjöllum",
    "fullName": " Tvær nætur á verði einnar í Kerlingarfjöllum"
  },
  "LAST_MINUTE": {
    "productType": "highlandPackage",
    "displayName": "Summer at Highland Base",
    "fullName": "Summer at Highland Base"
  },
  "RACK SLEEPING BAG": {
    "productType": "highlandPackage",
    "displayName": "Stay at Highland Base Huts",
    "fullName": "Stay at Highland Base Huts"
  },
  "HBE_NO TRANSFER": {
    "productType": "highlandPackage",
    "displayName": "No transfer",
    "fullName": "No transfer"
  },
  "RETREAT+MOSS": {
    "productType": "pagePackage",
    "displayName": "A night at The Retreat and Moss Restaurant",
    "fullName": "A night at The Retreat and Moss Restaurant"
  },
  "RETREAT_ROMANTIC": {
    "productType": "pagePackage",
    "displayName": "A Romantic Getaway",
    "fullName": "A Romantic Getaway"
  },
  "WELLNESS AND WONDER": {
    "productType": "pagePackage",
    "displayName": "Wellness & Wonder",
    "fullName": "Wellness & Wonder"
  },
  "RETREAT_REC": {
    "productType": "pagePackage",
    "displayName": "Curated by The Retreat",
    "fullName": "Curated by The Retreat"
  },
  "SILICA_ONLINE_RACK": {
    "productType": "pagePackage",
    "displayName": "Stay at Silica Hotel",
    "fullName": "Stay at Silica Hotel"
  },
  "SILICA_GOURMET": {
    "productType": "pagePackage",
    "displayName": "Classic Cuisine & In-Water Treatments",
    "fullName": "Classic Cuisine & In-Water Treatments"
  },
  "SILICA+LAVA": {
    "productType": "pagePackage",
    "displayName": "A Night at Silica Hotel with Dinner at Lava Restaurant​",
    "fullName": "A Night at Silica Hotel with Dinner at Lava Restaurant​"
  },
  "SIL+RETREATSPA": {
    "productType": "pagePackage",
    "displayName": "Silica Hotel & the Retreat Spa",
    "fullName": "Silica Hotel & the Retreat Spa"
  },
  "GOURMET GETAWAY": {
    "productType": "pagePackage",
    "displayName": "A Gourmet Getaway",
    "fullName": "A Gourmet Getaway"
  },
  "STAY LONGER": {
    "productType": "pagePackage",
    "displayName": "Stay Longer",
    "fullName": "Stay Longer"
  },
  "LUXURY GETAWAY": {
    "productType": "pagePackage",
    "displayName": "Luxury Getaway",
    "fullName": "Luxury Getaway"
  },
  "RETREAT_ONLINE_RACK": {
    "productType": "pagePackage",
    "displayName": "Stay at Retreat Hotel",
    "fullName": "Stay at Retreat Hotel"
  },
  "skincare-retreatspa": {
    "productType": "activityCard",
    "displayName": "Blue Lagoon skincare",
    "fullName": "Blue Lagoon skincare"
  },
  "privateTransferTheRetreat": {
    "productType": "activityCard",
    "displayName": "Book your private transfer",
    "fullName": "Book your private transfer"
  },
  "privateTransfer": {
    "productType": "activityCard",
    "displayName": "Book private transfers",
    "fullName": "Book private transfers"
  },
  "highlandBaseSummerTransfer": {
    "productType": "activityCard",
    "displayName": "Summer transfer",
    "fullName": "Summer transfer"
  },
  "highlandBaseEbike": {
    "productType": "activityCard",
    "displayName": "E-Mountain Bike Tour",
    "fullName": "E-Mountain Bike Tour"
  },
  "skincare": {
    "productType": "activityCard",
    "displayName": "Blue Lagoon skincare",
    "fullName": "Blue Lagoon skincare"
  },
  "spa-restaurant": {
    "productType": "activityCard",
    "displayName": "Dine at Spa Restaurant",
    "fullName": "Dine at Spa Restaurant"
  },
  "lava": {
    "productType": "activityCard",
    "displayName": "Reserve a table at Lava Restaurant",
    "fullName": "Reserve a table at Lava Restaurant"
  },
  "Snowmobile": {
    "productType": "activityCard",
    "displayName": "Snowmobile adventure ",
    "fullName": "Snowmobile adventure "
  },
  "highlandBaseHike": {
    "productType": "activityCard",
    "displayName": "Hverabotn daily hike",
    "fullName": "Hverabotn daily hike"
  },
  "highlandBaseBuggyRide": {
    "productType": "activityCard",
    "displayName": "Buggy tour",
    "fullName": "Buggy tour"
  },
  "samflot": {
    "productType": "activityCard",
    "displayName": "Group float activity",
    "fullName": "Group float activity"
  },
  "highlandBaseDayTour": {
    "productType": "activityCard",
    "displayName": "A day in Kerlingarfjöll",
    "fullName": "A day in Kerlingarfjöll"
  },
  "mossRestaurant": {
    "productType": "activityCard",
    "displayName": "Michelin-dining at Moss",
    "fullName": "Michelin-dining at Moss"
  },
  "highlandBaseBaths": {
    "productType": "activityCard",
    "displayName": "Highland Baths",
    "fullName": "Highland Baths"
  },
  "highlandBaseRestaurant": {
    "productType": "activityCard",
    "displayName": "Highland Base Restaurant",
    "fullName": "Highland Base Restaurant"
  },
  "float": {
    "productType": "activityCard",
    "displayName": "Book float therapy ",
    "fullName": "Book float therapy "
  },
  "massage": {
    "productType": "activityCard",
    "displayName": "Book an in-water massage",
    "fullName": "Book an in-water massage"
  }
};
